import { generatePath } from "react-router";
import type { Route } from "virtual:paths";

type GeneratePathParams<Path extends string> = NonNullable<
  Parameters<typeof generatePath<Path>>[1]
>;

/** Like react-router {@link generatePath} but with type checking against the given path string */
export function path$<Path extends Route = Route>(
  path: Path,
  params: GeneratePathParams<Path> = {} as GeneratePathParams<Path>,
): string {
  return generatePath(path, params);
}

/** Ensures the given path string is a valid route */
export function route$<Path extends Route = Route>(path: Path): Path {
  return path;
}
